import { createGlobalStyle } from 'styled-components'

export const VerificationGlobalStyles = createGlobalStyle`

.gpScreeningWidget {
        .container{
                background: white ;
                box-sizing: content-box !important;
                margin-top: 47px !important;
        }

        .buttonContainer{
            width: 100% !important;

            .nextButton{
                background-color: ${props => props.theme.color.button.main} !important;
                border-radius: 23px !important;
                height: 46px !important;
                width: 100% !important;
                color: #FFFFFF;
                font-size: 16px;
                font-weight: 600;
            }

            .nextButton:disabled{
                background-color:  ${props => props.theme.color.button.disabled} !important;

            }
        }

        .MuiFormLabel-root.Mui-focused{
            color: ${props => props.theme.color.primary.main} !important;
        }

        .labelBorder{
            color: ${props => props.theme.color.primary.main} !important;
        }

        .plus {
            margin-right: 5px !important;
        }

        .plus svg path{
            fill: ${props => props.theme.color.primary.main} !important;
        }

        .MuiButtonBase-root.Mui-checked span span{
            background-color: ${props => props.theme.color.primary.main}
        }

        .asterisk{
            color: ${props => props.theme.color.primary.main} !important;
        }

        .checkBoxes .checkboxDot::before{
            top: 3px !important;
        }

        .checkBoxes input[type="radio"]:checked + .checkboxDot{
            background-color: ${props => props.theme.color.primary.main} !important;
        }

        .videoUploadLabel, .imageUploadLabel{
            // display: none !important;
        }

        .videoWebCamFrame button, 
        .imageCamFrame button
        {
            border-color: ${props => props.theme.color.primary.main} !important;
        }

        .videoCameraText,
        .startImageCamButtonText
        {
                color: ${props => props.theme.color.primary.main} !important;
        }

        .videoWebCamFrame button #Oval,
        .imageCamFrame button #Oval
        {
            fill: ${props => props.theme.color.primary.main} !important;
        }

        .frameCorners{
            filter: invert(57%) sepia(34%) saturate(1500%) hue-rotate(125deg) brightness(180%) contrast(117%);
        }

    }

    #statement hr {
        background-color: #444444 !important;
        border-width: 2px;
    }

    #statement .table td, .table th {
        border-top: 1px solid #444444;
        border-bottom: 1px solid #444444 !important;
        vertical-align: middle !important;
    }

    #statement .total {
        background-color: #dddddd;
    }

    #statement h1, #invoice h3 {
        color: #1d3a6d;
    }
    @page {
        size: auto; /* auto is the initial value */
        margin: 0mm; /* this affects the margin in the printer settings */
    }
`
